import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { compose} from 'recompose';
// core components
var firebase = require("firebase");
var firebaseui = require("firebaseui");
import { connect } from 'react-redux';
import * as types from 'src/types';
import * as actions from '../../reducers/action-reducer'
import { AppSection } from "src/types";
let loginPageStyle={

}

interface ILogOutProps
{
    classes:any;
    connect:types.IState;
}
interface ILogOutState
{
   
}
class LogoutPage extends React.Component<ILogOutProps,ILogOutState> {
  constructor(props:ILogOutProps) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
   
    };
  }
  timeOutFunction:any;
  ui:any;
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    ;
    this.props.connect.dispatch(actions.clearProfile())
  }
  componentWillUnmount(){
   }
  render() {



    const { classes } = this.props;
    return(<div>Logging Out</div>)
  }
}


LogoutPage['propTypes'] = {
  classes: PropTypes.object.isRequired
};

export function mapStateToProps(state: types.IState) {
  //withStyles(loginPageStyle)(LoginPage)
  return {
    connect:state
    
  }


  
}
/*
export function mapDispatchToProps(dispatch: Dispatch<actions.EnthusiasmAction>) {
  return {
    onIncrement: () => dispatch(actions.incrementEnthusiasm()),
    onDecrement: () => dispatch(actions.decrementEnthusiasm()),
  }
}*/

//export default connect(mapStateToProps, mapDispatchToProps)(Hello);

export default compose(
  //@ts-ignore
  withStyles(loginPageStyle),
  connect(mapStateToProps, null)
)(LogoutPage);
//export default connect(mapStateToProps,null, withStyles(loginPageStyle)(LoginPage));
 


// WEBPACK FOOTER //
// ./src/views/pages/LogOutPage.tsx